
(function () {
  function addToCart(variantId, btn) {
    if (!variantId || (btn && btn.disabled)) return;

    if (btn) { btn.disabled = true; btn.dataset.loading = '1'; }

    // A pre-order size carries its ship date so the cart and the order show
    // the same "Est. Ship Date" line the product page adds.
    var payload = { id: Number(variantId), quantity: 1 };
    var preorderDate = btn && btn.getAttribute('data-preorder-date');
    if (preorderDate) payload.properties = { 'Est. Ship Date': preorderDate };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      var trigger = document.querySelector('.js-mini-cart-trigger');
      if (trigger) trigger.click();
    })
    .catch(function () {
    })
    .finally(function () {
      if (btn) { btn.disabled = false; delete btn.dataset.loading; }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pcard__size-btn');
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    e.preventDefault();
    addToCart(variantId, btn);
  }, true);
})();


// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".pcard__sizes-overlay").forEach(function(overlay){
//     const buttons = overlay.querySelectorAll("button");

//     if (overlay.getAttribute("aria-hidden") === "true") {
//       overlay.setAttribute("inert", "");
//       buttons.forEach(btn => btn.setAttribute("tabindex", "-1"));
//     }

//     const observer = new MutationObserver((mut)=> {
//       const hidden = overlay.getAttribute("aria-hidden") === "true";
//       if (hidden) {
//         overlay.setAttribute("inert", "");
//         buttons.forEach(btn => btn.setAttribute("tabindex", "-1"));
//       } else {
//         overlay.removeAttribute("inert");
//         buttons.forEach(btn => btn.removeAttribute("tabindex"));
//       }
//     });

//     observer.observe(overlay, { attributes: true, attributeFilter: ["aria-hidden"] });
//   });
// });

